import { API } from '../api';
import axiosInstance from '../axiosConfig';

export const getDefaultAppFee = async () => {
  const response = await axiosInstance.get(API.APP_FEE.GET_DEFAULT_FEE);
  return response;
};
export const updateDefaultAppFee = async (id, key, value) => {
  const response = await axiosInstance.patch(
    API.APP_FEE.UPDATE_DEFAULT_FEE + id + '/' + key + '/' + value
  );
  return response;
};
export const getAllBusinesses = async () => {
  const response = await axiosInstance.get(API.APP_FEE.GET_BUSINESS);
  return response;
};
export const updateBusinessAppFee = async (body) => {
  const response = await axiosInstance.post(API.APP_FEE.UPDATE_BUSINESS_FEE, body);
  return response;
};
export const updateLocationAppFee = async (body) => {
  const response = await axiosInstance.post(API.APP_FEE.UPDATE_LOCATION_FEE, body);
  return response;
};
